<template>
    <div class="flex flex-wrap text-slate-200 mb-12 p-4">
        <div class="w-full md:w-3/5 border-r border-r-slate-600/50 pr-4">
                <h2 class="header-class"><vue-feather type="mail" size="20px" class="-mb-[2px]" aria-hidden="true"/> Make Contact</h2>
                <div v-if="$page.url!='/contact/posted'" class="box flex flex-wrap contact">
                    <div class="w-full">
                        <form method="POST" action="?" accept-charset="UTF-8" id="contactform"
                            @submit.prevent="submitForm">
                            <div class="form-group mb-4">
                                <label for="name">Name<span class="required">*</span></label>
                                <input id="name" required :class="inputClass()" v-model="contents.name" placeholder="Name" />
                                <div v-if="checkErrors('name')" class="error">{{ errors.name }}</div>
                            </div>
                            <div class="form-group mb-4">
                                <label for="email">Email<span class="required">*</span></label>
                                <input id="email" required :class="inputClass()" v-model="contents.email" type="text"
                                    placeholder="Email Address" />
                                <span v-if="checkErrors('email')" class="error">{{ errors.email }}</span>
                            </div>
                            <div class="form-group mb-4">
                                <label for="phone">Phone Number</label>
                                <input id="phone" :class="inputClass()" v-model="contents.phone" type="tel"
                                    placeholder="000-000-0000 or similar" />
                            </div>
                            <div class="form-group mb-4">
                                <label for="description">Body<span class="required">*</span></label>
                                <textarea placeholder="Body" v-model="contents.message" cols="30" rows="5"
                                    id="description" :class="inputClass()"></textarea>
                                <span v-if="checkErrors('message')" class="error">{{ errors.message }}</span>
                            </div>
                            <div class="form-group mb-4">
                                <label for="question">What planet are we on?<span class="required">*</span></label>
                                <input id="question" :class="inputClass()" @keyup="checkContents" v-model="contents.planet"
                                    type="text"
                                    placeholder="You are here. Type the word earth like you and I are on the same planet"
                                    autocomplete="off" />
                                <span v-if="checkErrors('planet')" class="error">{{ errors.planet }}</span>
                            </div>
                            <input type="hidden" v-model="contents._token">
                            <div class="form-group">
                                <button type="submit"
                                    class="button  enabled:bg-yellow-800 enabled:text-white disabled:bg-yellow-400/50 disabled:text-yellow-500  text-white my-4 pt-1 h-10 !px-24"
                                    :disabled="(invalid ? true : false)">SEND</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-else class="box p-4 flex flex-wrap contact">
                    <p>Thank you! I will reach out shortly.</p>
                </div>
        </div>
        <div class="w-full md:w-2/5 socials pl-4">
            <h1 class="header-class mb-2">
                <vue-feather type="headphones" size="20px" class="-mb-[2px]" aria-hidden="true"/>
                Socials
            </h1>
            <div class="box flex flex-wrap ">
                <div class="order-first md:order-last rounded-md w-full text-center md:text-left pt-6">
                    <ul class="no-bullet no-pad">
                        <li class="flex flex-wrap justify-between object-center mb-4 ">
                            <a href="https://www.instagram.com/ac00perw/" class="block mr-4" aria-label="Adam Wood on Instagram">
                                <vue-feather type="instagram" size="36px" aria-hidden="true" />
                            </a>
                            <a href="https://youtube.com/acooperw/" class="block mt-0 ml-4" aria-label="Adam Wood on YouTube">
                                <vue-feather type="youtube" size="40px" aria-hidden="true" />
                            </a>
                            <a href="https://soundcloud.com/ac00perw" class="block mt-0 ml-6" aria-label="Adam Wood on SoundCloud">
                                <vue-feather type="headphones" size="36px" aria-hidden="true" />
                            </a>
                        </li>
                    </ul>
                    <h2 class="header-class">Musics</h2>
                    <ul class="creds flex flex-wrap object-center mb-4 text-base">
                        <li class="mb-2 w-full md:w-1/2">
                            <ul class="w-full leading-loose">
                                <li class="uppercase">Shitcan Noisebelt</li>
                                <li class="-ml-1"><a href="https://shitcannoisebelt.bandcamp.com/">Bandcamp</a>
                                    &nbsp;<a href="https://soundcloud.com/shitcan-noisebelt">Sound Cloud</a>
                                </li>
                                <li class="text-sm">Experimental music with <a
                                        href="https://antaragatch.bandcamp.com/">Chris Cheney</a> and occasionally
                                    <a href="https://swale.bandcamp.com/">Jeremy Frederick</a>, <a
                                        href="https://highdivervt.bandcamp.com/">Jeremy Frederick</a>, and <a
                                        href="https://physicsclub.ninja">Jeremy Frederick</a>
                                </li>
                            </ul>
                        </li>
                        <li class="mb-2 w-full md:w-1/2">
                            <a class="uppercase -ml-1" href="https://physicsclub.ninja">Physics Club</a>
                            <p class="text-sm">Irene, Rex, and Abraham make beautiful Christmas Music</p>
                        </li>
                        <li class="mb-2 w-full md:w-1/2">
                            <a class="uppercase -ml-1" href="https://soundcloud.com/ac00perw">Adam Wood Sound Cloud</a>
                            <p class="text-sm">My personal SoundCloud account. More of the music from the playlist.
                            </p>
                        </li>
                        <li class="mb-2 w-full md:w-1/2">
                            <a class="uppercase -ml-1" href="https://digthree.bandcamp.com/">Digthree</a>
                            <p class="text-sm">Trio from the late 1990s early 2000s with Eric Rohrbach (d), Jon
                                Akland (b), and me (k). </p>
                        </li>
                    </ul>
                    <!-- <p><a href="/web-development">Skills List</a></p> -->
                </div>
            </div>
            <div>
                <h2 class="header-class"><vue-feather type="database" size="18px" class="-mb-[2px] mr-1" aria-hidden="true"/>API Credits</h2>
                <ul class="flex flex-wrap">
                    <li class="w-1/2">
                        Basketball data: <a href="https://www.balldontlie.io/">BallDontLie</a>
                    </li>
                    <li class="w-1/2">
                        Movie pics: <a href="https://www.themoviedb.org/" rel="nofollow">The Movie DB</a>
                    </li>
                    <li class="w-1/2">
                        TV pics: <a href="https://www.thetvdb.com/" rel="nofollow">The TVDB</a>
                    </li>
                    <li class="w-1/2">
                        Bird pics: <a href="https://donate.wikimedia.org/" rel="nofollow">WikiMedia</a>
                    </li>
                    <li class="w-full">
                        Recipe pics: Ripped from their respective recipe pages.
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>
<script>
    import { mapState } from 'pinia'
    import { useGeneralStore } from '@/utils/useGeneralStore.js'
    import GuestLayout from "@/Layouts/GuestLayout.vue";
    import { router } from '@inertiajs/vue3'

    export default {
        name: 'contact',
        layout: GuestLayout,
        props: ['token', 'ip', 'foo'],
        computed: {
            ...mapState(useGeneralStore, ['bbSectionHeader', 'containerClass', 'headerClass']),
        },
        watch: {
            contents(n) {
                if (n.planet == 'earth') {
                    this.invalid = false;
                }
            },
            '$page.url': {
                handler (n) {
                    if(n == '/contact/posted') {
                        setTimeout(() => {
                            router.visit('/contact');
                        }, 6000);
                    }
                },
                immediate: true
            }
        },
        data() {
            return {
                contents: [],
                submiterror: '',
                response: 0,
                invalid: true,
                errors: [],
                subsubheaderClass: 'text-left pl-2 font-mono text-xl text-amber-500'
            }
        },
        mounted() {
            if (import.meta.env.MODE === 'development') {
                this.contents = {
                    'email': 'address@acdubs.com',
                    'name': 'Adam',
                    'phone': '802-888-8888',
                    'planet': 'earth',
                    'message': 'msg'
                };
            }
            this.contents = { ...this.contents, '_token': window.token };

        },
        methods: {
            checkContents() {
                if (this.contents?.planet === 'earth') {
                    this.invalid = false;
                    this.errors.planet = null;
                } else {
                    this.invalid = true;
                    this.errors.planet = "This planet";
                }
            },
            checkErrors(x) {
                return this.errors && this.errors[x] ? true : false;
            },
            inputClass(a = '') {
                return `border-1 border-amber-600 border-solid p-2 w-full placeholder:text-white ${a}`;
            },
            doClick() {
                // bus.$emit('navigationEvent', 'contact');
            },
            submitForm(e) {
                if (this.contents.planet !== 'earth') {
                    this.errors.planet = "Are you sure that's the planet we live on?";
                    return false;
                }
                if (this.contents.message.length < 1) {
                    this.errors.message = "Why not write me a message?";
                    return false;
                }

                router.post('/post-contact', this.contents);
            }
        }
    }
</script>
<style lang="css">
    label {
        @apply ml-1 text-sm uppercase text-amber-200 bg-none;
    }

    .required {
        @apply text-red-500;
    }

    .error {
        @apply w-full text-base text-red-200 bg-amber-900 px-4;
        /* font-size: .6em; */
    }

    input,
    textarea {
        @apply text-base rounded-sm;
        background-color: var(--primary-darker);
    }

    .creds a {
        @apply hover:bg-yellow-400/20 hover:bg-opacity-100 text-yellow-200 p-1;
    }
</style>
